import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Fitness.module.css';
import { DBRadioButton } from '_components';


class PatientCareCenterNoteSubjectiveFitness extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_fitness' name='Fitness' level={1} className={this.props.isWc ? styles.required : ''}>
                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBFITNESS'
                        label='Exercise 0 times per week'
                        selectedValue='Exercise 0 times per week'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBFITNESS'
                        label='Exercise 1-2 times per week'
                        selectedValue='Exercise 1-2 times per week'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBFITNESS'
                        label='Exercise 3+ times per week'
                        selectedValue='Exercise 3+ times per week'
                        className={styles.col2}
                    />
                </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let isWc = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO].isWc;

    return {
        noteId: noteId,
        evno: evno,
        isWc
    };
}

const connectedPatientCareCenterNoteSubjectiveFitness = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveFitness);
export { connectedPatientCareCenterNoteSubjectiveFitness as PatientCareCenterNoteSubjectiveFitness };

